// TopBar.jsx
import React from 'react';
import { useState, useRef, useEffect } from 'react';

import brand_logo from "../img/brand_logo.png"
import profile_picture from "../img/profile_picture.png"
import icon_bell from "../img/icon_bell.png"
import { Link } from 'react-router-dom';
import {download_app} from '../api/api.js';

import {get_user_notifications, mark_notification_as_read} from '../api/api.js';

const TopBar = () => {

  //TODO eeeeh
  const user_name = localStorage.getItem("first_name")+" "+localStorage.getItem("last_name");
  const user_role = localStorage.getItem("role");
  const user_id = localStorage.getItem("user_id");

  const user={ name: user_name, role: user_role }
  const [open, setOpen] = useState(false);
  const [notifications, setNotifications] = useState({});
  const [aretherenotifications, setAretherenotifications] = useState(false);
  const [notificationsOpen, setNotificationsOpen] = useState(false);

  const menuRef = useRef(null);
  const notificationMenuRef = useRef(null);

  const path_admin = "/admin";
  const path_logs = "/logs";
  const path_logout = "/login";





  const logout = () => {
    localStorage.removeItem("role");
    localStorage.removeItem("first_name");
    localStorage.removeItem("last_name");
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    window.location.href=path_logout;
  }


  const download_the_app = () => {
    download_app();
  }

  // Close the menu when clicking outside
  useEffect(() => {

    (async () => {
      const notifiche = await get_user_notifications();
      setNotifications(notifiche.data);

      var arethere = false;
      if(notifiche && notifiche.data && notifiche.data.length){
        arethere = true;
      }

      setAretherenotifications(arethere);
      console.log(notifiche.data);
      console.log("aretherenotifications");
      console.log(aretherenotifications);
    })()  ;


    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
      if (notificationMenuRef.current && !notificationMenuRef.current.contains(event.target)) {
        setNotificationsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);






  return (
    <div className="top-bar">
      <div className="content">
        <div className="logo">
          <img src={brand_logo} alt="logo" />
        </div>


        <div className="profile-left-part">

                {/* Ref goes here */}
                <div ref={notificationMenuRef} className="relative">




                    {/* Notifications */}
                    {aretherenotifications && (
                    <div className="profile-contents" >
                      <div className="profile-icon-outer" onClick={() => setNotificationsOpen(!notificationsOpen)}>
                        <img className="profile-icon" alt="bell" src={icon_bell} />
                        {notifications && notifications.length > 0 && (
                          <span className="notification-counter">
                            {notifications.length}
                          </span>
                        )}
                      </div>

                      {notificationsOpen && notifications && (
                        <div className="relative inline-block text-left">
                          <div className="dropdown2">
                            {notifications.map((n) => (
                              <div key={n.id} className="dropdown2-item p-3 border-b border-gray-200 text-sm hover:bg-gray-50">
                                <div className="dropdown2-item-txt">
                                  {n.text}
                                </div>
                                <button
                                  className="dropdown2-item-btn block text-xs text-blue-500 mt-1"
                                  onClick={async () => {
                                    await mark_notification_as_read(n.id);
                                    if(notifications && notifications.length==1){
                                      setNotificationsOpen(false);
                                      setAretherenotifications(false);
                                    }
                                    setNotifications((prev) => prev.filter((x) => x.id !== n.id));


                                  }}
                                >
                                  segna come letto
                                </button>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}


                    </div>
                    )}


                </div>


                {/* Ref goes here */}
                <div ref={menuRef} className="relative">



                  <div className="profile-contents" onClick={() => setOpen(true)}>
                    <div className="profile-icon-outer">
                      <img className="profile-icon" src={profile_picture} alt="Profile" />
                    </div>
                    <div className="profile-data">
                      <div className="profile-data-name">{user.name}</div>
                      <div className="profile-data-role">{user.role}</div>
                    </div>
                  </div>


                  {open && (
                    <div className="relative inline-block text-left">
                      <div className="dropdown">
                        <Link to={path_admin} onClick={() => setOpen(false)} >
                          <span className="dropdown-item" style={{display: user_role==='Admin' ? 'block':'none'}}>Pannello Admin</span>
                        </Link>

                        <Link to={path_logs} onClick={() => setOpen(false)} >
                          <span className="dropdown-item" style={{display: user_role==='Admin' ? 'block':'none'}}>Registro Operazioni</span>
                        </Link>

                        <span className="dropdown-item" onClick={download_the_app}>Scarica App</span>

                        <span className="dropdown-item" onClick={logout}>Logout</span>
                      </div>
                    </div>
                  )}
                </div>



      </div>
      </div>
    </div>

  );
};

export default TopBar;
